export const getUrlKey = (name) => {
  return (
    decodeURIComponent(
      (new RegExp("[?|&]" + name + "=" + "([^&;]+?)(&|#|;|$)").exec(
        location.href
      ) || [, ""])[1].replace(/\+/g, "%20")
    ) || null
  );
};

export const isPc = () => {
  let userAgentInfo = navigator.userAgent;
  let Agents = [
    "Android",
    "iPhone",
    "SymbianOS",
    "Windows Phone",
    "iPad",
    "iPod",
  ];
  let flag = true;
  for (var v = 0; v < Agents.length; v++) {
    if (userAgentInfo.indexOf(Agents[v]) > 0) {
      flag = false;
      break;
    }
  }
  return flag;
};

export const isPortraitFun = () => {
  let clientWidth = document.documentElement.clientWidth;
  let clientHeight = document.documentElement.clientHeight;
  // clientWidth > 768 &&
  if (clientWidth > clientHeight) {
    return false;
  } else {
    return true;
  }
};

//设置cookie
export const setCookie = (name, value) => {
  document.cookie = `${name}=${encodeURIComponent(
    value
  )}; domain=${GetCookieDomain()};path=/;`;
};

//获取cookie
export const getCookie = (name) => {
  let arr,
    reg = new RegExp("(^| )" + name + "=([^;]*)(;|$)");
  if ((arr = document.cookie.match(reg))) return decodeURIComponent(arr[2]);
  else return null;
};

export const GetCookieDomain = () => {
  let host = location.hostname;
  let ip =
    /^(\d{1,2}|1\d\d|2[0-4]\d|25[0-5])\.(\d{1,2}|1\d\d|2[0-4]\d|25[0-5])\.(\d{1,2}|1\d\d|2[0-4]\d|25[0-5])\.(\d{1,2}|1\d\d|2[0-4]\d|25[0-5])$/;
  if (ip.test(host) === true || host === "localhost") return host;
  let regex = /([^]*).*/;
  let match = host.match(regex);
  if (typeof match !== "undefined" && null !== match) host = match[1];
  if (typeof host !== "undefined" && null !== host) {
    let strAry = host.split(".");
    if (strAry.length > 1) {
      host = strAry.splice(1).join(".");
    }
  }
  return "." + host;
};

/**
 * 获取url参数
 * @param {String} url
 * @returns {Object} Params
 */
export const getUrlParams = (url) => {
  const Params = {};
  if (url.indexOf("?") > 0) {
    //判断是否有qurey
    let parmas = url.slice(url.indexOf("?") + 1); //截取出query
    const paramlists = parmas.split("&"); //分割键值对
    for (const param of paramlists) {
      let a = param.split("=");
      Object.assign(Params, { [a[0]]: decodeURIComponent(a[1]) }); //将键值对封装成对象
    }
  }
  return Params;
};

// 获取广告投放链接中的参数
export const getADUrlParam = () => {
  const { utm_source, utm_soid, utm_activity, mz_ca, mz_sp } = getUrlParams(
    window.location.href
  );

  utm_source && setCookie("utm_source", utm_source);
  utm_soid && setCookie("utm_soid", utm_soid);
  utm_activity && setCookie("utm_activity", utm_activity);
  mz_ca && setCookie("mz_ca", mz_ca);
  mz_sp && setCookie("mz_sp", mz_sp);

  return {
    utm_source: utm_source || getCookie("utm_source") || "",
    utm_soid: utm_soid || getCookie("utm_soid") || "",
    utm_activity: utm_activity || getCookie("utm_activity") || "",
    mz_ca: mz_ca || getCookie("mz_ca") || "",
    mz_sp: mz_sp || getCookie("mz_sp") || "",
  };
};

// 节流
//func：需要执行的函数
//delay：自己设定的间隔时间（频率）
//immediate：是否立即执行，值为true则第一次触发立刻执行函数，默认为false是最后一次触发执行
//return：返回可被调用执行的函数
export function throttle(func,delay,immediate){
  //func为需要节流的函数，delay为节流的时间，immediate为是否需要先执行
  var timer = null;
  return function(){
    var context = this;
    var args = arguments;
    if(timer) clearTimeout(timer);
    if(immediate){
      //根据距离上次触发操作的时间是否到达delay来决定是否要现在执行函数
      var doNow = !timer;
      //每一次都重新设置timer，就是要保证每一次执行的至少delay秒后才可以执行
      timer = setTimeout(function(){
        timer = null;
      },delay);
      //立即执行
      if(doNow){
        func.apply(context,args);
      }
    }else{
      timer = setTimeout(function(){
        func.apply(context,args);
      },delay);
    }
  }
}
// 防抖
//func：需要执行的函数
//wait：检测防抖的间隔频率
//immediate：是否立即执行，值为true则第一次触发立刻执行函数，默认为false是最后一次触发执行
//return：返回可被调用执行的函数
export function debounce(func,wait=500,immediate=false){
  let timer=null;		//通过timer设置为null检测是否出现了定时器
  return function(...params){
    let now=immediate && !timer;  //immediate为true，timer为null时，now为true
    clearTimeout(timer);
    timer=setTimeout(()=>{
      timer=null;
      !immediate?func.call(this,...params):null;
    },wait);
    now?func.call(this,...params):null;  //now为true则为第一次触发，则立即执行
  }
}

// 判断是否为微信浏览器
export function isWeiXin(){
  //window.navigator.userAgent属性包含了浏览器类型、版本、操作系统类型、浏览器引擎类型等信息，这个属性可以用来判断浏览器类型
  let ua = window.navigator.userAgent.toLowerCase();
  //通过正则表达式匹配ua中是否含有MicroMessenger字符串
  if(ua.match(/MicroMessenger/i) == 'micromessenger'){
    return true;
  } else{
    return false;
  }
}

// 判断是否为Android系统
export function isAndroid(){
  let ua = window.navigator.userAgent.toLowerCase();
  //通过正则表达式匹配ua中是否含有MicroMessenger字符串
  if(ua.indexOf('Android') > -1 || ua.indexOf('Adr') > -1 || ua.indexOf('adr') > -1 || ua.indexOf('android') > -1){
    return true;
  } else{
    return false;
  }
}

// 判断是
export function isSafariFun() {
  var isSafari = /^((?!chrome|android).)*safari/i.test(navigator.userAgent);
  console.log(isSafari);
  return isSafari
  //判断是否Safari浏览器
}

/**
 * 埋点点击方法
 * @param {String} name 事件名称
 * Params
 */
export function maidian(name) {
  console.log(name);
  try {
    stm_clicki("send", "event", window.location.href+'页面', "点击", name);
  } catch (e) {
    console.error(e);
  }
}
